import React from 'react'

import {
    Form,
    Tabs,
  Badge,
  TabBar,
  Button,ImageViewer,SideBar,List,Image,Grid,Popup,Stepper,Modal, Toast,Avatar,FloatingBubble
} from 'antd-mobile-v5';
import { HandPayCircleOutline,StarOutline,DownCircleOutline } from 'antd-mobile-icons'
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs'

import BottomMenu from '../../comronent/BottomMenu/index';
import 'antd/dist/antd.css';
import '../../assets/font/font.css'
import '../Index/index.css'

import {
    GetPlanets
} from '../../service/service';

import { environment } from '../../service/baseUrl';

const withNavigate = (WrappedComponent) => {
    return (props) => {
        const navigate = useNavigate();
        return <WrappedComponent {...props} navigate={navigate} />;
    };
};

class Index extends React.Component {
    formRef = React.createRef();

    constructor(props) {
        super(props);
        this.state = {
            users: [],
            dataMsg: "数据加载中...",

            visibleQF: false,
            visibleQFOver: false,
            visibleXH: false,
            visibleImg: false,

            offset: {
                x: -140, 
                y: -450
            },
            offsets: [],
        };
    }

    componentDidMount() {
        var that = this;

        //星星位置
        // var offsets = [];
        // var json = localStorage.getItem("offsets");
        // if (json != null && json != "") {
        //     offsets = JSON.parse(json)
        // } else {
        //     offsets = [];
        // }
        // that.setState({
        //     offsets: offsets
        // })

        // 1. 安全读取本地存储
        const loadOffsets = () => {
            try {
                const json = localStorage.getItem("offsets");
                return json ? JSON.parse(json) : [];
            } catch (error) {
                console.error("读取位置数据失败:", error);
                return [];
            }
        };

        // 2. 异步获取数据并合并位置
        const fetchData = async () => {
            const offsets = loadOffsets();

            try {
                const res = await GetPlanets();
                if (res.success) {
                    const users = res.result.map(item => {
                        // 找到对应的 offset 数据
                        const matchedOffset = offsets.find(x => x.id === item.id);
                        // 返回新对象，保留原有属性并设置 offset
                        return {
                            ...item,
                            offset: matchedOffset ? matchedOffset.offset : that.state.offset
                        };
                    });

                    this.setState({
                        users,
                        offsets
                    });
                }
            } catch (error) {
                console.error("获取星球数据失败:", error);
            }
        };

        fetchData();


        // GetPlanets().then(res => {
        //     debugger
        //     if (res.success) {
        //         res.result.map(item => {
        //             item.offset = that.state.offset;

        //             var model = offsets.filter(x => x.id == item.id);
        //             if (model.length > 0) {
        //                 item.offset = model[0].offset
        //             }
        //         })
        //         that.setState({
        //             users: res.result
        //         })
        //     }

        // })


        const script = document.createElement('script');
        script.src = "https://niannian.weibinyi.com/index_DH.js";
        script.async = true;
        document.body.appendChild(script);

    }

    


    render() {

        

        return (
            <div id="index" className="index" style={{ width: "100%", height: "100%" }}>

                <div id="stars" className="stars"></div>


                {
                    this.state.users.map(item => {
                        return (<FloatingBubble
                            axis='xy' key={`bubble-${item.id}`}
                            style={{
                                '--initial-position-bottom': '12%',
                                '--initial-position-right': '24px',
                                '--edge-distance': '24px',
                                '--size': '70px',
                                '--border-radius': '0',
                                '--background': '#ffffff00',
                            }}
                            onClick={() => {
                                this.props.navigate('/home?planetId=' + item.id, { replace: true, state: { id: item.id } });
                            }}
                            onOffsetChange={offset => {
                                this.setState(prevState => {
                                    // 创建新的offsets数组
                                    const newOffsets = [
                                        ...prevState.offsets.filter(x => x.id !== item.id),
                                        { id: item.id, offset }
                                    ];

                                    // 更新对应的user
                                    const newUsers = prevState.users.map(user =>
                                        user.id === item.id ? { ...user, offset } : user
                                    );

                                    // 保存到本地存储
                                    localStorage.setItem("offsets", JSON.stringify(newOffsets));

                                    return {
                                        users: newUsers,
                                        offsets: newOffsets
                                    };
                                });
                            }}
                            offset={item.offset}
                        >
                            <div style={{ width: "100%", textAlign: "center" }}>
                                <Image
                                    src={"https://api.weibinyi.com/images/niannian/4/3-08.png"}
                                    width={70}
                                    height={70}
                                    fit='cover'
                                    style={{ margin: "auto", marginTop: "-20px" }}
                                />
                                <div style={{
                                    color: "#fff",
                                    fontSize: "10px",
                                    marginTop: "-20px",
                                    lineHeight: "1.2",
                                    whiteSpace: "nowrap",
                                    overflow: "visible",
                                    textOverflow: "clip"
                                }}>
                                    <div>{item.name}</div>
                                    <div style={{ marginTop: "3px", }}>
                                        {dayjs(item.birthday).format("YYYY.MM.DD") +
                                            "-" +
                                            dayjs(item.deadDate).format("YYYY.MM.DD")}
                                    </div>
                                </div>
                            </div>
                        </FloatingBubble>)
                    })
                }


                {/* <div style={{ position: "absolute", bottom: "19%", width: "100%", zIndex: "9999999" }}>
                    <div style={{
                        backgroundImage: "url('https://api.weibinyi.com/images/niannian/4/3-07.png')",
                        backgroundRepeat: "no-repeat", backgroundSize: "100% 100%", height: "40px", width: "80%",
                        marginLeft: "10%", textAlign: "center", lineHeight: "40px", color: "#fff", fontSize: "15px"
                    }} onClick={() => {
                        this.props.navigate('/planet', { replace: true }); // 传递状态
                    }}>
                        免费创建一颗星球
                            </div>
                </div> */}



                <div id="xingqiu" style={{ position: "absolute", bottom: "12%", width: "100%", display: "none" }}>

                    <div style={{ fontSize: "19px", color: "#fff", marginBottom: "10px", marginLeft: "10px" }}>
                        我的星球
                    </div>

                    <div style={{ width: "100%" }}>
                        <div style={{
                            width: "135px",
                            backgroundColor: "rgb(110 110 110 / 56%)",
                            border: "solid 1px #848484",
                            height: "180px",
                            borderRadius: "8%",
                            marginLeft: "5%",
                            float: "left"
                        }} onClick={() => {
                            this.props.navigate('/home', { replace: true, state: { from: 'home' } }); // 传递状态
                        }}>
                            <div style={{ marginTop: "14%" }}>
                                <Avatar src=''
                                    style={{ '--size': '55px', '--border-radius': '35px', 'margin': 'auto' }} />
                            </div>
                            <div style={{ textAlign: "center", marginTop: "5%", color: "#fff", fontSize: "14px" }}>张三三</div>
                            <div style={{ textAlign: "center", marginTop: "3%", color: "#d7d7d7", fontSize: "12px" }}>
                                已化作星星100天
                            </div>
                            <div style={{ textAlign: "center", color: "#eaeaea", fontSize: "23px", marginTop: "6%" }}>
                                <DownCircleOutline />
                            </div>
                        </div>
                        
                        <div style={{
                            width: "135px",
                            backgroundColor: "rgb(110 110 110 / 56%)",
                            border: "solid 1px #848484",
                            height: "180px",
                            borderRadius: "8%",
                            marginLeft: "5%",
                            float: "left"
                        }} onClick={() => {
                            this.props.navigate('/home', { replace: true, state: { from: 'home' } }); // 传递状态
                        }}>
                            <div style={{ marginTop: "28%" }}>
                                <Avatar src=''
                                    style={{ '--size': '55px', '--border-radius': '35px', 'margin': 'auto' }} />
                            </div>
                            <div style={{ textAlign: "center", marginTop: "13%", color: "#fff", fontSize: "14px" }}>
                                免费创建
                            </div>
                        </div>
                        

                    </div>
                </div>
                




                <div className="landscape" style={{ }}></div>
                <div className="filter" style={{  }}></div>
                <canvas id="canvas"></canvas>


                <BottomMenu position="absolute" selectKey="home" />
                
            </div>
        )
    }
}

export default withNavigate(Index);